import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ImageContainer } from 'components'

export class PrintSheet extends Component {

    static propTypes = {
        id: PropTypes.string.isRequired,
        sheet: PropTypes.object.isRequired,
        forcedScale: PropTypes.number.isRequired,
        margin: PropTypes.object.isRequired,
        title: PropTypes.string.isRequired,
    }

    printArea = null

    render() {
        const { id, sheet, frame, forcedScale, margin } = this.props

        const sheetStyles = {
            width: sheet.width,
            height: sheet.height,
        }

        const titleHeight = 12
        const titleStyles = {
            height: `${titleHeight}px`,
            top: margin.top / 2,
            left: margin.left,
            width: sheet.width - margin.left - margin.right
        }

        const imageStyles = {
            padding: `${margin.top -titleHeight}px ${margin.right}px ${margin.bottom}px ${margin.left}px`
        }

        return (
            <div className="sheet" style={sheetStyles}>
                <div className="media-title" style={titleStyles}>
                    { this.props.title }
                </div>
                <div style={imageStyles}>
                    <ImageContainer id={id} frame={frame} forcedScale={forcedScale} ref={"image"} isInteractive={true} />
                </div>
            </div>
        )
    }
}
